export const FOLLOWING_FEED_NAME = 'following';
export const FOLLOWING_INFINITE_SCROLL_LIMIT_PER_REQUEST = 80;
